import React, { useEffect, useState } from 'react'
import {
  Modal, Form, Input, Switch, message,
} from 'antd'

import { fetch } from '../../utils/fetch'

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
}

const MasterSiteModal = ({
  visible, onSuccess, onCancel, editItem,
}) => {
  const [action, setAction] = useState('')
  const [form] = Form.useForm()

  const createMasterSite = (values) => {
    fetch({
      method: 'POST',
      url: '/master-data/master-site',
      data: values,
    }).then((res) => {
      if (res?.data?.success) {
        form.resetFields()
        message.success('Created Success')
        onSuccess(values)
      } else {
        message.error(res?.data?.message)
      }
    })
  }

  const updateMasterSite = (values) => {
    fetch({
      method: 'PUT',
      url: `/master-data/master-site/${values.siteCode}`,
      data: values,
    }).then((res) => {
      if (res?.data?.success) {
        form.resetFields()
        message.success('Updated Success')
        onSuccess(values)
      } else {
        message.error(res?.data?.message)
      }
    })
  }

  useEffect(() => {
    if (!editItem) {
      form.resetFields()
      setAction('Create')
    } else {
      setAction('Edit')
      form.setFieldsValue(editItem)
    }
  }, [editItem, form])

  const cancelModal = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      title={`${action} Master Site`}
      visible={visible}
      maskClosable={false}
      okText="Submit"
      cancelText="Cancel"
      onCancel={cancelModal}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            if (action === 'Create') {
              createMasterSite(values)
            }
            if (action === 'Edit') {
              updateMasterSite(values)
            }
          })
          .catch((info) => {
            console.log('Master Site Validate Failed:', info)
          })
      }}
    >
      <Form
        {...layout}
        form={form}
        name="master_site_form"
        layout="horizontal"
        initialValues={editItem}
        preserve={false}
      >
        <Form.Item
          label="Site Code"
          name="siteCode"
          rules={[{
            required: true,
            message: 'site code is required',
          }]}
        >
          <Input disabled={editItem} />
        </Form.Item>
        <Form.Item
          label="Site Description"
          name="siteDescr"
          rules={[{
            required: true,
            message: 'site description is required',
          }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Active"
          name="isActive"
          valuePropName="checked"
        >
          <Switch defaultChecked />
        </Form.Item>
      </Form>
    </Modal>

  )
}

export default MasterSiteModal
